import { render, staticRenderFns } from "./BaseOutlinePrimaryButton.vue?vue&type=template&id=0e0d620c&scoped=true&"
import script from "./BaseOutlinePrimaryButton.vue?vue&type=script&lang=js&"
export * from "./BaseOutlinePrimaryButton.vue?vue&type=script&lang=js&"
import style0 from "./BaseOutlinePrimaryButton.vue?vue&type=style&index=0&id=0e0d620c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e0d620c",
  null
  
)

export default component.exports